'use client';

import { ApproveDeclineRequestForm } from '@/components/forms';
import { ModalWrapper } from '@/components/organisms/ModalWrapper';
import { ApproveDeclineRequestData } from '@/entities';

interface ApproveDeclineRequestModalProps {
	fullName: string;
	teamName: string;
	onSubmit: (action: 'approve' | 'decline') => void;
	onClose: () => void;
}

export const ApproveDeclineRequestModal = ({ fullName, teamName, onSubmit, onClose }: ApproveDeclineRequestModalProps) => {
	const handleFormSubmit = (_data: ApproveDeclineRequestData) => {
		onSubmit(_data.approvePlayerRequest ? 'approve' : 'decline');
	};

	return (
		<ModalWrapper className="!max-w-[525px] !gap-0" title="Approve or Decline player request" onClose={onClose} closeOnOutsideClick={true}>
			<ApproveDeclineRequestForm fullName={fullName} teamName={teamName} onSubmit={handleFormSubmit} onClose={onClose} />
		</ModalWrapper>
	);
};
